import { memo } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useTypedSelector } from "hooks";
import type { Setup, WithClonnable } from "features/setups/types";
import { selectSetupsSlice } from "features/setups/selectors";
import { selectSetupActiveCompany } from "features/general/selectors";
import { useResourceContext } from "ui/widgets/Resource";
import type { ActionProps } from "./types";

const Clone = ({ row }: ActionProps) => {
    const slice = useTypedSelector(selectSetupsSlice());
    const activeDomains = useTypedSelector(selectSetupActiveCompany);
    const { onOpen } = useResourceContext<WithClonnable<Setup<string>>>();

    const clone = () => onOpen({
        ...row,
        clonnable: true
    });

    const disabled = activeDomains.every(domain => (
        slice.data
            .some((setup: Setup<string>) => (
                Object.is(setup.identifier, row.identifier) &&
                Object.is(setup.valueType, row.valueType) &&
                Object.is(setup.MOR, domain)
            ))
    ));

    return (
        <ListItem disablePadding>
            <ListItemButton
                disabled={disabled}
                onPointerDown={clone}
            >
                <ListItemText primary="Clone" />
            </ListItemButton>
        </ListItem>
    );
};

export default memo(Clone);
